// This is a type only import, it is fixed in later version of typescript.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import i18n from 'i18next';
import {
  MeasurementSystem,
  FitnessApplicationSettings,
  DistanceUnit,
} from './../../types/__generated__';

const ImperialLanguages = ['en-gb', 'en-us', 'my'];

export const getMeasurementSystemFallback = () => {
  if (!i18n?.languages) return MeasurementSystem.Metric;
  const language = i18n.languages.length
    ? i18n.languages[0].toLowerCase()
    : null;

  if (language === null) return MeasurementSystem.Metric;
  return ImperialLanguages.includes(language)
    ? MeasurementSystem.Imperial
    : MeasurementSystem.Metric;
};

export const getMeasurementSystemFromSettings = (
  settings: FitnessApplicationSettings | null | undefined,
) => {
  return settings?.measurementSystem ?? getMeasurementSystemFallback();
};

export const getDistanceUnitForMeasurementSystem = (
  measurementSystem: MeasurementSystem,
) =>
  measurementSystem === MeasurementSystem.Metric
    ? DistanceUnit.Metres
    : DistanceUnit.Feet;
